import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsNew from "@/components/WhatsNew";
import { Outlet } from "react-router-dom";
import { Toaster } from "sonner";

export default function Layout() {
    return (
        <>
            {/* Site-wide Saltire watermark — the Scottish flag, fixed to the
                viewport at 10% opacity so it reads as a whisper of national
                identity rather than a shout. Sits behind everything. */}
            <div className="saltire-bg" aria-hidden data-testid="saltire-bg" />
            <Navbar />
            <WhatsNew />
            <main className="pt-24 min-h-screen relative" style={{ zIndex: 1 }} data-testid="page-main">
                <Outlet />
            </main>
            <Footer />
            <Toaster theme="dark" position="bottom-right" />
        </>
    );
}
